<template>
  <v-dialog
    v-model="isShowModal"
    :max-width="'480px'"
    persistent>
    <v-card>
      <material-card
        :title="$t('common.changePassword')"
        tile
        color="green"
        full-width
      >
        <v-container grid-list>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation>
            <v-layout
              wrap>
              <v-flex
                xs12
                sm12
                md12>
                <div style="position: relative;">
                  <v-text-field
                    :rules="[ruleRequiredValue]"
                    v-model="oldPassword"
                    :label="$t('common.currentPassword')"
                    :name="$t('common.currentPassword')"
                    :type="isShowCurrentPassword ? 'text' : 'password'"
                    prepend-icon="mdi-lock"
                    class="required"
                  />
                  <v-icon
                    style="position: absolute; right: 0; top: 25%; cursor: pointer;"
                    @mousedown="isShowCurrentPassword=true"
                    @mouseleave="isShowCurrentPassword=false"
                    @mouseup="isShowCurrentPassword=false">{{ isShowCurrentPassword ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
                </div>
              </v-flex>
              <v-flex
                xs12
                sm12
                md12>
                <div style="position: relative;">
                  <v-text-field
                    :rules="[ruleRequiredValue, ruleValidPassword]"
                    v-model="newPassword"
                    :label="$t('common.newPassword')"
                    :name="$t('common.newPassword')"
                    :type="isShowNewPassword ? 'text' : 'password'"
                    prepend-icon="mdi-lock"
                    class="required"
                  />
                  <v-icon
                    style="position: absolute; right: 0; top: 25%; cursor: pointer;"
                    @mousedown="isShowNewPassword=true"
                    @mouseleave="isShowNewPassword=false"
                    @mouseup="isShowNewPassword=false">{{ isShowNewPassword ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
                </div>
              </v-flex>
              <v-flex
                xs12
                sm12
                md12>
                <div style="position: relative;">
                  <v-text-field
                    :rules="[ruleRequiredValue, ruleSamePassword]"
                    v-model="newPassword2"
                    :label="$t('common.confirmPassword')"
                    :name="$t('common.confirmPassword')"
                    :type="isShowConfirmPassword ? 'text' : 'password'"
                    prepend-icon="mdi-lock"
                    class="required"
                  />
                  <v-icon
                    style="position: absolute; right: 0; top: 25%; cursor: pointer;"
                    @mousedown="isShowConfirmPassword=true"
                    @mouseleave="isShowConfirmPassword=false"
                    @mouseup="isShowConfirmPassword=false">{{ isShowConfirmPassword ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
                </div>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </material-card>
      <v-card-actions>
        <v-spacer />
        <v-btn
          small
          color="error darken-1"
          @click="onCloseModal"
        >{{ $t("common.close") }}
        </v-btn>
        <v-btn
          :is-loading="isLoading"
          small
          color="success darken-1"
          @click="onConfirm"
        >{{ $t("common.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <snack-bar
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    />
  </v-dialog>
</template>

<script>
import functionUtils from 'utils/functionUtils'
import validationRules from 'utils/validationRules'
import ToastType from 'enum/toastType'
import { mapActions, mapGetters } from 'vuex'

export default {
  data: () => ({
    valid: false,
    isShowModal: false,
    oldPassword: null,
    newPassword: null,
    newPassword2: null,
    isShowCurrentPassword: false,
    isShowNewPassword: false,
    isShowConfirmPassword: false,
    isLoading: false
  }),
  computed: {
    ...mapGetters([
      'GET_SNACK_BAR'
    ])
  },
  methods: {
    // Required value
    ruleRequiredValue (value) {
      return validationRules.ruleRequiredValue(value)
    },
    ruleValidPassword (value) {
      return validationRules.ruleValidPassword(value)
    },
    ruleSamePassword (value) {
      return validationRules.ruleSamePassword(value, this.newPassword, this.oldPassword)
    },
    onConfirm: function () {
      if (this.$refs.form.validate()) {
        // this.$emit('onPasswordChanged', this.password)
        let data = {
          oldPassword: this.oldPassword,
          newPassword: this.newPassword
        }
        this.CHANGE_PASSWORD(data).then(
          function () {
            this.ON_SHOW_TOAST({
              message: this.$t('server.common.successed'),
              styleType: ToastType.SUCCESS
            })
            this.isShowModal = false
          }.bind(this)
        ).catch(
          function (error) {
            this.ON_SHOW_TOAST({
              message: this.$t(functionUtils.errorResponse(error.response)),
              styleType: ToastType.ERROR
            })
          }.bind(this)
        )
      }
    },
    onCloseModal: function () {
      this.isShowModal = false
    },
    onShowModal: function () {
      // Reset the form validation state and inputs using the ref
      this.$refs.form.reset()
      this.isShowModal = true
    },
    ...mapActions([
      'CHANGE_PASSWORD',
      'ON_SHOW_TOAST'
    ])
  }
}
</script>

<style lang="scss" scoped>
.modal {
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}
.v-card {
  margin-bottom: 0px !important;
  margin-top: 21px !important;
}
:deep(.required label::after) {
  content: " *";
  color: red;
}
</style>
